module.exports = __webpack_public_path__ + "img/Frame-75.acafcfa9.svg";